import { forwardRef } from 'react';
import SanitizedHTML from 'react-sanitized-html';
import { usePlanCtx } from '../../../planDetailsContext';
import { SectionConatiner } from '../../ui-blocks/containers';
import { SectionHeading } from '../../ui-blocks/typograpghy';
import { ISection } from '../types';

const ServicesIncluded: React.FC<ISection> = forwardRef(
  ({ id, name }, ref: React.ForwardedRef<HTMLDivElement>) => {
    const planDetails = usePlanCtx();

    return (
      <div data-testid={id} id={id} ref={ref}>
        {planDetails.servicesIncluded.length ? (
          <SectionConatiner>
            <SectionHeading>{name}</SectionHeading>
            <div className="flex pt-5 sm:flex-col">
              <div className="w-3/5 sm:w-full">
                {planDetails.servicesIncluded.map((service, idx) => {
                  return (
                    <div key={idx} className="flex items-center pt-2">
                      <img
                        src="https://assets1.cleartax-cdn.com/cleartax/images/1675169708_group17512.svg"
                        alt="tick"
                        className="w-4 h-4"
                      />
                      <div className="text-brand-1000 ml-4 font-medium">
                        <SanitizedHTML html={service.richText} />
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="w-2/5 sm:w-full sm:pt-6 sm:flex sm:justify-center">
                <img
                  src="https://assets1.cleartax-cdn.com/cleartax/images/1675231424_group10000025201.png"
                  alt="lady"
                />
              </div>
            </div>
          </SectionConatiner>
        ) : null}
      </div>
    );
  }
);

export { ServicesIncluded };
